module.exports = __webpack_public_path__ + "static/mission-c27927105035e22696d892782beb02ef.svg";